export default __webpack_public_path__ + "static/heroSectionBg-07f10c6037b95ac2f360ed745a28cbec.png";